// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.legand {
    border: 1px solid #c9c9c9;
    padding: 10px;
    border-radius: 4px;
    position: relative;
    margin-top: 20px;
}

.legand-title {
    background: #fff;
    top: -11px;
    padding: 0 4px 0 8px;
    position: absolute;
    z-index: 0;
    height: 20px;
}

.galery-body {
    position: fixed;
    left: 0;
    top: 0;
    background: #fff;
    right: 0;
    z-index: 1111;
    bottom: 0;
    overflow: auto;
}

button#kt_quick_panel_close_btn {
    top: 1.5rem;
}

.kt-quick-panel__nav {
    padding-top: 1rem
}`, "",{"version":3,"sources":["webpack://./src/app/views/view-builder/block-settings/block-settings.component.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,aAAa;IACb,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,oBAAoB;IACpB,kBAAkB;IAClB,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,OAAO;IACP,MAAM;IACN,gBAAgB;IAChB,QAAQ;IACR,aAAa;IACb,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI;AACJ","sourcesContent":[".legand {\r\n    border: 1px solid #c9c9c9;\r\n    padding: 10px;\r\n    border-radius: 4px;\r\n    position: relative;\r\n    margin-top: 20px;\r\n}\r\n\r\n.legand-title {\r\n    background: #fff;\r\n    top: -11px;\r\n    padding: 0 4px 0 8px;\r\n    position: absolute;\r\n    z-index: 0;\r\n    height: 20px;\r\n}\r\n\r\n.galery-body {\r\n    position: fixed;\r\n    left: 0;\r\n    top: 0;\r\n    background: #fff;\r\n    right: 0;\r\n    z-index: 1111;\r\n    bottom: 0;\r\n    overflow: auto;\r\n}\r\n\r\nbutton#kt_quick_panel_close_btn {\r\n    top: 1.5rem;\r\n}\r\n\r\n.kt-quick-panel__nav {\r\n    padding-top: 1rem\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
